
import React from 'react';
import PropTypes from 'prop-types';

import GM1IMG from '../InstallImages/GroundMountImages/GM1';
import GM2IMG from '../InstallImages/GroundMountImages/GM2';
import GM5IMG from '../InstallImages/GroundMountImages/GM5';


import '../saleslogic.css';
import '../../../../../../grid.css';

const GroundMount = (props) => {
    const {
        firstName,
    } = props;

    // images are 952 x 406

    return (
        <div className="row" >
            <h1 className="arrayType">Ground Mount</h1>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">{firstName}, after analyzing and comparing your annual electrical consumption to the site-specific conditions at your location, we conclude that your PV solar-generating system should be installed on the ground using a ground-mounted racking system. Your land is the ideal place to maximize your benefits and ensure that the entire system meets or exceeds your expectations. We base our decision on decades of experience and careful consideration of many factors, including available equipment components, open roof area, the impact of obstructions, the effect of shading, your previous 12-month’s electrical consumption, and available ground space. We upgraded the pipe dimensions from 2” diameter to 3” diameter Schedule 40 Galvanize Steel, and selected Techno Metal Posts™ technology rather than inferior pier-footings. </p>
                <p className="col span-2-of-3 installPics"><GM1IMG /></p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics"><GM2IMG /></p>
                <p className="col span-1-of-3 installText"> By installing your ground-mount racking system at the specified pitch and azimuth, Solvana also saves you money by maximizing the kilowatt-hour (kWh) energy production from your PV solar-generating system. Solvana also designed and engineered your ground-mounted racking system to complement the warranties on the selected modules, inverters, and rail components, to build your complete PV solar-generating system. Solvana also engineered the entire system to make it easier to remove at the end of its useful life. Solvana is proud of the efficient way we use materials in our designs to achieve net-zero residual-impacts on the environment. </p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">
                    Pictured left, a pic of a 108-module ground-mounted PV solar-generating system installed in 2010 in Hunterdon County, NJ. Co-Founder Ric Breines has over four decades of excavation experience, and nothing beats experience. Peace of mind begins with choosing Solvana to design, engineer, permit, build, and commission your PV solar-generating system.
                </p>
                <p className="col span-2-of-3 installPics"><GM5IMG /></p>
            </div>
        </div>
    );
};

GroundMount.propTypes = {
    firstName: PropTypes.string.isRequired,
};

export default GroundMount;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/GroundMount/GroundMount.js